import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatearNumero',
  standalone: true
})
export class FormatearNumeroPipe implements PipeTransform {

  transform(valor: number): string {
    if (isNaN(valor)) {
      return ''; 
    }

    const partes = valor.toFixed(2).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); 
    return `${partes.join(',')}`;
  }

}
